import React, { useCallback, useEffect, useState } from "react";
import "../styles/partner.css";
import default_image from "../assets/images/default.png";
import { Link, useNavigate } from "react-router-dom";
import { isFieldWithValue } from "../utils";
import { API } from "../config/api";
import { LocalStorage } from "../config/localstorage";
import { useUser } from "../contexts/UserContext";

const Unregister = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    phone: "",
    password: "",
    hasError: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { user, setUser } = useUser();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (user) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("here");
    if (isFieldWithValue(phone) && isFieldWithValue(password)) {
      setIsLoading(true);
      onLogin();
    } else {
      setErrors({
        phone: isFieldWithValue(phone)
          ? ""
          : "Le numéro de téléphone est invalide",
        password: isFieldWithValue(password)
          ? ""
          : "Le mot de passe est invalide",
        hasError: true,
      });
    }
  };

  const onLogin = async () => {
    try {
      const response = await API.Authentication({
        phone: `+221${phone}`,
        password,
      });
      const { data, success, message } = response.data;
      if (success) {
        LocalStorage.setLocalStorageItem("token", data.access_token);
        setUser(data);
      } else {
        setErrors({
          phone: "",
          password: "",
          hasError: true,
          message,
        });
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const handlePhoneChange = (e) => {
    try {
      const value = e.target.value;
      if (value === "" || /^[0-9]+$/.test(value)) {
        setPhone(value);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const hasPhoneError = useCallback(() => {
    return errors.hasError && !isFieldWithValue(phone);
  }, [errors, phone]);

  const hasPasswordError = useCallback(() => {
    return errors.hasError && !isFieldWithValue(password);
  }, [errors, password]);

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      {/* Left Section - Image */}
      <div className="lg:w-1/2 relative bg-primary">
        {/* Back button */}
        <div className="absolute top-6 left-6 z-10">
          <Link to="/">
            <button className="text-white bg-white/10 px-4 py-2 rounded-full text-sm backdrop-blur-sm">
              ← Retourner à l'accueil
            </button>
          </Link>
        </div>

        {/* Logo */}
        <div className="absolute top-6 left-6 lg:left-10">
          <img src="/logo.svg" alt="Logo" className="h-8" />
        </div>

        {/* Background Image */}
        <div className="h-[80vh] lg:h-full relative">
          <img
            src={default_image}
            alt="Desert landscape"
            className="w-full h-full object-cover"
          />
          <div className="absolute top-20 left-10 text-white">
            <h2 className="text-3xl lg:text-4xl font-light mb-4">
              Vous nous quitter <span className="enso-bold">déjà ?</span>
            </h2>
          </div>
        </div>
      </div>

      {/* Right Section - Form */}
      <div className="lg:w-1/2 p-8 lg:p-16 bg-[#1c1c24]">
        <div className="max-w-md mx-auto">
          <h1 className="text-4xl text-secondary mb-4 enso-bold">
            Suppression de votre compte Dalal
          </h1>
          <p className="text-gray-400 mb-8">
            Chez DALAL, la protection des données personnelles de nos
            utilisateurs est une priorité.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">1. Développeur</p>
          <p className="text-gray-400 mb-8">
            Cette application est publiée par KINZ SAS en collaboration avec
            Humble Software GROUP.
          </p>

          <p className="text-gray-400 mb-2 enso-bold">
            1. Comment supprimer votre compte ?
          </p>
          <p className="text-gray-400 mb-8">
            Pour demander la suppression de votre compte, veuillez suivre les
            étapes suivantes : <br />
            * Connectez-vous à votre compte DALAL. <br />
            * Accédez à la section "Profil". <br />
            * Cliquez sur "Supprimer mon compte". <br />* Confirmez la
            suppression : cette action est irréversible.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            2. Quelles données seront supprimées ?
          </p>
          <p className="text-gray-400 mb-8">
            Lors de la suppression de votre compte, toutes vos données
            personnelles, et vos informations de profil, seront supprimées de
            manière permanente.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            3. Quelles données sont conservées ?
          </p>
          <p className="text-gray-400 mb-8">
            Certaines données peuvent être conservées temporairement pour des
            raisons juridiques ou de sécurité : * Données de facturation : si
            vous avez effectué des achats via l'application, certaines
            informations de facturation peuvent être conservées pour des raisons
            fiscales. <br />
            * Historique des transactions : nous pouvons conserver un historique
            de vos transactions pour des raisons de conformité.
            <br />* Données anonymisées : nous pouvons conserver des données
            anonymisées à des fins d'analyse et d'amélioration de nos services.
          </p>
          <p className="text-gray-400 mb-2 enso-bold">
            Si vous ne parvenez pas à accéder à votre compte, vous pouvez également nous contacter à l’adresse : kinzsas@gmail.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unregister;
